import React, { useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import Logo from '../Logo';
import { fmt } from '../../utils';

const FilaTablaEstadisticasListas = ({
  item,
  ambito,
  index,
  isMobile,
  nomenclator,
}) => {
  const t = useTranslate();
  const infoSectores = nomenclator.sectores;
  const { codpar, cantotabla } = item.act;
  const partido = nomenclator.partidos[Number(codpar) - 1];
  const valuePorcentaje = item.act.pvot.replace('%', '');
  const restPercent = (100 - valuePorcentaje).toString().concat('%');
  const showLogo= item.act.cam === "3";
  return (
    <>
      <TableRow key={`i${index}c${item.act.codpar}`}>
        {!isMobile ? (
          <>
            <div css="width:70%; height:100%;">
              <div css="width:100%; height:100%">
                {!isMobile && <StyledLogo codpar={partido.codpar} ambito={ambito}/>}
                <ContainerNombreList
                  color={infoSectores[item.act.cam].color}
                  porcentaje={item.act.pvot}
                  restPercent={restPercent}
                >
                  <Grafica
                    color={infoSectores[item.act.cam].color}
                    porcentaje={item.act.pvot.replace(',', '.')}
                  />
                  <div css="display: flex; height: 100%; align-items: center; ">
                    <p
                      css="position: relative; line-height: 12px; margin-left: 25px;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 12px;"
                    >
                      {partido.nombre}
                    </p>
                  </div>
                </ContainerNombreList>
              </div>
            </div>
            <div css="width:29%; text-align:center;">
              <PorcentajeTexto>{fmt(item.act.vot)}</PorcentajeTexto>
              <span>{item.act.pvot}</span>
            </div>
          </>
        ) : (
          <>
            <div css="width:67%; height:100%;">
              <div css="width:100%; height:100%">
                <ContainerNombreListMobile
                  color={infoSectores[item.act.cam].color}
                  porcentaje={item.act.pvot}
                  restPercent={restPercent}
                >
                  <Grafica
                    color={infoSectores[item.act.cam].color}
                    porcentaje={item.act.pvot.replace(',', '.')}
                  />
                  <div>
                    <PartidoMobile
                    >
                      {partido.nombre}
                    </PartidoMobile>
                  </div>
                </ContainerNombreListMobile>
              </div>
            </div>
            <div
              css="    width: 30%;
    text-align: center;
    display: flex;
    justify-content: flex-end;
    align-items: center;"
            >
              <div>
                <PorcentajeTextoMobile>{fmt(item.act.vot)}</PorcentajeTextoMobile>
                <p>{item.act.pvot}</p>
              </div>
            </div>
          </>
        )}
      </TableRow>
    </>
  );
};

export default FilaTablaEstadisticasListas;

const TableRow = styled.li`
  height: 44px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  background: #f0f0f0;
  margin-bottom: 2px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
const Cell = styled(({ width, ...rest }) => <div {...rest} />)`
  vertical-align: middle;
  flex: 0 0 ${({ width }) => width};
`;

const Button = styled.button`
  border: none;
  display: block;
  margin: auto;
  width: 44px;
  height: 44px;
  background-color: transparent;
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  height: 44px;
  background: rgba(0, 0, 0, 0.08);
`;

const CircleColor = styled(({ color, ...rest }) => <span {...rest} />)`
  vertical-align: middle;
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 20px;
  @media (max-width: 768px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const PorcentajeTexto = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  margin-right: 10px;
  text-align: center;
  letter-spacing: 0.3px;
  color: #222222;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;

const ContainerBarra = styled.div`
  width: 70%;
`;

const BarraSector = styled(({ width, color, ...rest }) => <div {...rest} />)`
  width: ${({ width }) => width};
  background-color: ${({ color }) => color};
  height: 4px;
`;

const ContainerNombreList = styled(
  ({ color, porcentaje, restPercent, ...rest }) => <div {...rest} />
)`
  width: 80%;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  position: relative;
`;

const Grafica = styled(({ color, porcentaje, ...rest }) => <div {...rest} />)`
  height: 100%;
  width: ${({ porcentaje }) => porcentaje};
  position: absolute;
  background: ${({ color }) => color};
  display: inline-block;
  vertical-align: top;
  opacity: 0.5;
`;

const Nombre = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #222222;
  margin-left: 15%;
`;

const ContenedorNombreMobile = styled.div`
  width: 70%;
  height: 100%;
`;

const ContenedorVotosMobile = styled.div`
  width: 30%;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const PorcentajeTextoMobile = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  margin-right: 10px;
  text-align: center;
  letter-spacing: 0.3px;
  color: #222222;
  @media (max-width: 768px){
    line-height: 19px;
    margin-right: 10px;
  }
`;

const ContainerNombreListMobile = styled(
  ({ color, porcentaje, restPercent, ...rest }) => <div {...rest} />
)`
  width: 80%;
  height: 100%;
  display: flex;
  vertical-align: top;
  position: relative;
  align-items: center;
`;

const PartidoMobile = styled.p`
  position: relative;
  line-height: 14px;
  margin-left: 3px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
`;
